// extracted by mini-css-extract-plugin
module.exports = {"Switcher":"styles_Switcher__4wADE","switcher":"styles_switcher__oF9_X","isActive":"styles_isActive__R7_Rx"};